/** The URL of a document's PC sheet (2.H deliverable 5): `/sheets/pc/<docId>[?sheet=<id>]`. */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export interface CharacterSheetHrefOptions {
  readonly sheetId?: string | undefined;
}

export function characterSheetHref(docId: string, options: CharacterSheetHrefOptions = {}): string {
  return `/sheets/pc/${docId}${options.sheetId ? `?sheet=${options.sheetId}` : ''}`;
}

export interface CharacterSheetSearch {
  readonly sheet?: string;
}

/** Keeps `sheet` when it is a uuid and drops anything else, without throwing. */
export function validateCharacterSheetSearch(
  search: Record<string, unknown>,
): CharacterSheetSearch {
  return typeof search.sheet === 'string' && UUID.test(search.sheet) ? { sheet: search.sheet } : {};
}
